import { useState, useEffect } from 'react';
import { getFolders, createFolder, deleteFolder } from '../utils/localStorage';

export const useFolders = () => {
  const [folders, setFolders] = useState([]);

  const loadFolders = () => {
    const data = getFolders();
    setFolders(data);
  };

  useEffect(() => {
    loadFolders();
  }, []);

  const addFolder = (name, color) => {
    const newFolder = createFolder(name, color);
    setFolders([...folders, newFolder]);
    return newFolder;
  };

  const removeFolderById = (folderId) => {
    deleteFolder(folderId);
    setFolders(folders.filter(f => f.id !== folderId));
  };

  const refreshFolders = () => {
    loadFolders();
  };

  return {
    folders,
    addFolder,
    removeFolder: removeFolderById,
    refreshFolders,
    loading: false
  };
};
